import { baseFetchToken } from './BaseSaga'
import ExchangeRateActions from '../Redux/ExchangeRateRedux'
import { getToken } from '../Services/GetToken'

export function * getExchangeRate (api, action) {
  yield baseFetchToken(api.getExchangeRate,
    action.data,
    getToken,
    ExchangeRateActions.exchangeRateSuccess,
    ExchangeRateActions.exchangeRateFailure)
}

export function * getSingleExchangeRate (api, action) {
  yield baseFetchToken(api.getSingleExchangeRate,
    action.data,
    getToken,
    ExchangeRateActions.exchangeRateSingleSuccess,
    ExchangeRateActions.exchangeRateSingleFailure)
}

export function * updateExchangeRate (api, action) {
  yield baseFetchToken(api.updateExchangeRate,
    action.data,
    getToken,
    ExchangeRateActions.exchangeRateUpdateSuccess,
    ExchangeRateActions.exchangeRateUpdateFailure)
}



// WEBPACK FOOTER //
// ./src/Sagas/ExchangeRateSagas.js